module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "dedicationPage",
    attrs: {
      "id": "ded01"
    }
  }, [_c('p', {
    staticClass: "dedicationText"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("For:")])]), _vm._v(" "), _c('p', {
    staticClass: "dedicationText"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Alice Anne Carroll, my grandmother")])]), _vm._v(" "), _c('p', {
    staticClass: "dedicationText"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Emily Carroll Bell, my mother")])]), _vm._v(" "), _c('p', {
    staticClass: "dedicationText"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Alice Carroll George Davidson, my daughter")])]), _vm._v(" "), _c('p', {
    staticClass: "dedicationText"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Emily Anne Davidson, my granddaughter")])]), _vm._v(" "), _c('p', {
    staticClass: "dedicationText1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("How impossible to contend")])]), _vm._v(" "), _c('p', {
    staticClass: "dedicationText1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Where I stop and you begin.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5cb6c9d4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/dedication.vue
// module id = 63
// module chunks = 0